import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'describe_the_most_representative_department_win_the_fac'

export const dataPointDefinition = {
  retracedId: 'describe_the_most_representative_department_win_the_fac',
  name: 'Describe the most representative department within the facility:',
  description:
    '"Most representative department" means the department in the facility with the highest number of workers. \r\r\n\r\r\nWorkers are persons working on/with the facility\'s product or directly involved in the operations of the facility. They are non-supervisory, which means no one reports to them.',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-40',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8360,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
